import {Directive, effect, ElementRef, inject, input, InputSignal} from "@angular/core";
import {CssVarHelper} from "./css-var.helper";
import {ConfigurationModel} from '../configuration/configuration.model';

@Directive({
    selector: "[woa-css-var]"
})
export class CssVarDirective {
    private element: ElementRef = inject(ElementRef);
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);

    public readonly cssVars: InputSignal<Record<string, string | number | boolean | (string | number | boolean)[]>> = input<Record<string, string | number | boolean | (string | number | boolean)[]>>({}, {alias: "woa-css-var"});

    constructor() {
        effect(() => {
            this.configurationModel.app();
            CssVarHelper.applyVars(this.element.nativeElement, this.cssVars());
        });
    }
}
